/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import keyBy from 'lodash/fp/keyBy';
import { TableState } from '../../components/common/table/types';
import { Ticket, ticketFromDTO } from '../../shared/entities/ticket';
import { Action, ActionCreators } from './actions';

const keyById = keyBy<Ticket>('id');

export interface TicketsState extends TableState<Ticket> {}

export const initialTicketsState: TicketsState = {
  loading: false,
  error: null,
  options: {
    filters: [],
    sort: { key: 'updatedDate', sortKey: 'UPDATED_DATE', direction: false },
    limit: 10,
    page: 0,
  },
  nextOptions: null,
  total: 0,
  projection: [],
  map: {},
};

export default function reducer(state: TicketsState = initialTicketsState, action: Action): TicketsState {
  let partialState: Partial<TicketsState> | undefined;

  switch (action.type) {
    case ActionCreators.FetchTicketsPending.type:
      partialState = {
        loading: true,
        options: { ...state.options, ...action.meta.options },
      };
      break;

    case ActionCreators.FetchTicketsFulfilled.type: {
      const tickets = action.payload.response.tickets.map(ticketFromDTO);

      partialState = {
        loading: false,
        error: null,
        options: action.meta.options,
        nextOptions: null,
        total: action.payload.response.totalTickets,
        projection: tickets.map(t => t.id),
        map: {
          ...state.map,
          ...keyById(tickets),
        },
      };
      break;
    }

    case ActionCreators.FetchTicketsRejected.type:
      partialState = {
        loading: false,
        error: action.payload,
        nextOptions: null,
        total: 0,
        projection: [],
        map: {},
      };
      break;

    default:
      return state;
  }
  return { ...state, ...partialState };
}
